import React from "react"
import ContentTransformer from "./Transformers/content-transformer"
import PropTypes from "prop-types"

const AdditionalInformation = ({ node }) => {
  if (node.field_infos_complementaires?.processed) {
    return (
      <div>
        <ContentTransformer
          content={node.field_infos_complementaires.processed}
        />
      </div>
    )
  }
  return null
}

//-----------------------Prop-Types---------------------------//

AdditionalInformation.propTypes = {
  node: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default AdditionalInformation
